<div class="container mx-auto py-8">
  <div
    class="flex flex-col sm:flex-row justify-between sm:items-center mb-[24px]"
  >
    <h3
      class="md:text-[28px] sm:text-[24px] text-[24px] md:leading-[33px] sm:leading-[31px] leading-[29px] text-blue-theme-color font-bold"
    >
      {{ countryFromLocal === "Ghana" ? "Inter-Regional" : "Inter-State" }}
      Order Details
    </h3>

    <div class="flex flex-col sm:flex-row pt-4 sm:pt-0 gap-3">
      <div class="flex items-center">
        <button
          mat-ripple
          (click)="shareOrder()"
          class="!text-blue-theme-color flex items-center gap-1 px-2 py-1 rounded border border-blue-200 bg-transparent hover:!bg-blue-50"
        >
          <!-- <mat-icon class="mat-18">share</mat-icon> -->
          <span class="ml-1 text-[14px] !text-blue-theme-color"
            >Share Tracking Info</span
          >
        </button>
        <mat-icon
          class="mat-18 ml-1 !text-blue-theme-color cursor-help"
          matTooltip="Consolidated Tracking Info: View every stop, package, and tracking status in this order in one place. Intended for internal or sender use only. For recipients, share the individual tracking link from each drop-off location so they see only their own package."
          matTooltipClass="large-tooltip"
          matTooltipPosition="above"
        >
          info
        </mat-icon>
      </div>

      <button mat-flat-button (click)="onBack()" class="!text-orange-color">
        <mat-icon class="mat-18">arrow_back</mat-icon>
        <span class="ml-[5px] text-[18px] !text-orange-color">Back</span>
      </button>
    </div>
  </div>

  <!-- Loading State with Shimmer -->
  <div *ngIf="isLoading" class="flex flex-col lg:flex-row gap-6">
    <!-- Left Section Shimmer -->
    <div class="flex-1 flex flex-col gap-6">
      <!-- Header & Order Info Shimmer -->
      <div class="shimmer-card">
        <div class="flex items-center justify-between">
          <div class="flex items-center gap-3">
            <div class="shimmer shimmer-circle"></div>
            <div>
              <div
                class="shimmer shimmer-text-small"
                style="width: 120px"
              ></div>
              <div
                class="shimmer shimmer-text-large"
                style="width: 150px"
              ></div>
            </div>
          </div>
          <div
            class="shimmer shimmer-text"
            style="width: 80px; height: 24px"
          ></div>
        </div>
      </div>

      <!-- Pickup Location Shimmer -->
      <div class="shimmer-card">
        <div class="shimmer shimmer-text" style="width: 140px"></div>
        <div class="shimmer shimmer-text-large" style="width: 200px"></div>
        <div class="shimmer shimmer-text-small" style="width: 250px"></div>
        <div class="flex items-center gap-2 mt-2">
          <div
            class="shimmer shimmer-circle"
            style="width: 20px; height: 20px"
          ></div>
          <div class="shimmer shimmer-text-small" style="width: 100px"></div>
        </div>
      </div>

      <!-- Dropoff Locations Shimmer -->
      <div class="shimmer-card" *ngFor="let item of [1, 2, 3]">
        <div class="flex justify-between items-center">
          <div class="shimmer shimmer-text-large" style="width: 160px"></div>
          <div class="flex gap-2">
            <div class="shimmer shimmer-text-small" style="width: 140px"></div>
            <div
              class="shimmer shimmer-circle"
              style="width: 24px; height: 24px"
            ></div>
          </div>
        </div>

        <!-- Expanded content shimmer -->
        <div class="mt-4">
          <div class="shimmer shimmer-text-large" style="width: 180px"></div>
          <div class="shimmer shimmer-text-small" style="width: 220px"></div>

          <div class="shimmer-grid">
            <div *ngFor="let gridItem of [1, 2, 3, 4]">
              <div class="shimmer shimmer-text-small" style="width: 80px"></div>
              <div class="flex items-center gap-1 mt-1">
                <div
                  class="shimmer shimmer-circle"
                  style="width: 22px; height: 22px"
                ></div>
                <div
                  class="shimmer shimmer-text-small"
                  style="width: 60px"
                ></div>
              </div>
            </div>
          </div>
        </div>

        <!-- Tracking Information Shimmer -->
        <div class="bg-[#FDF9F8] py-[20px] px-[25px] mt-4">
          <div
            class="shimmer shimmer-text-large"
            style="width: 180px; margin-bottom: 24px"
          ></div>

          <div class="relative">
            <div
              class="shimmer"
              style="height: 2px; width: 100%; margin-bottom: 24px"
            ></div>

            <div class="relative flex justify-between">
              <div
                class="shimmer-tracking-step"
                *ngFor="let step of [1, 2, 3, 4]"
              >
                <div class="shimmer shimmer-tracking-circle"></div>
                <div class="shimmer shimmer-tracking-text"></div>
                <div class="shimmer shimmer-tracking-text-small"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Right Section: Payment Summary Shimmer -->
    <div class="w-full lg:w-[350px] flex-shrink-0">
      <div class="shimmer-card">
        <div
          class="shimmer shimmer-text-large"
          style="width: 140px; margin-bottom: 16px"
        ></div>

        <!-- Payment items shimmer -->
        <div
          *ngFor="let item of [1, 2, 3, 4, 5]"
          class="flex justify-between mb-3"
        >
          <div class="shimmer shimmer-text-small" style="width: 120px"></div>
          <div class="shimmer shimmer-text-small" style="width: 60px"></div>
        </div>

        <hr class="my-3 border-[#E3E3E3]" />

        <div class="flex justify-between mb-3">
          <div class="shimmer shimmer-text" style="width: 140px"></div>
          <div class="shimmer shimmer-text" style="width: 80px"></div>
        </div>

        <hr class="my-3 border-[#E3E3E3]" />

        <div class="flex justify-between items-center">
          <div class="shimmer shimmer-text-large" style="width: 120px"></div>
          <div class="shimmer shimmer-text-large" style="width: 100px"></div>
        </div>
      </div>
    </div>
  </div>

  <!-- Actual Content -->
  <div *ngIf="!isLoading && !error" class="flex flex-col lg:flex-row gap-6">
    <!-- Left Section -->
    <div class="flex-1 flex flex-col gap-6">
      <!-- Header & Order Info -->
      <div
        class="bg-white border border-[#D8DFE7] rounded-xl p-6 flex flex-col gap-2 relative"
      >
        <div class="flex items-center justify-between">
          <div class="flex items-center gap-3">
            <img
              src="assets/images/ui/order_sym.png"
              class="w-12 h-12 object-contain"
              alt="Order Icon"
            />
            <div>
              <p class="text-sm text-[#7C8390]">
                {{ order?.date }} | {{ order?.time }}
              </p>
              <h2 class="text-lg font-bold text-blue-theme-color mb-0">
                #{{ order?.orderNumber }}
              </h2>
            </div>
          </div>
          <!-- <p class="tracking-step-description text-xs sm:text-sm">
            {{orderDetail | json}}
            
            {{ orderDetail?.isSchedule == 1 ? getFormattedScheduleDate() : dropLocation?.pickupTimeRange }}
          </p> -->
          <span
            class="px-3 py-1 rounded border border-[#2CA13F] text-[#2CA13F] text-xs font-medium"
            *ngIf="order?.status === 'In Transit'"
            >In Transit</span
          >
        </div>

        <mat-divider *ngIf="driver"></mat-divider>

        <!-- driver profile box -->
        <div *ngIf="driver" class="flex flex-col gap-2 mt-2">
          <h4 class="text-[#7C8390]">Driver Details</h4>

          <div
            class="flex flex-col sm:flex-row justify-between sm:items-center gap-4"
          >
            <div class="flex gap-[10px]">
              <div class="relative">
                <ng-container *ngIf="driver?.photo; else noImage">
                  <img
                    [src]="driver?.photo"
                    alt="Driver"
                    class="w-[70px] h-[50px] object-cover rounded-full"
                  />
                </ng-container>

                <ng-template #noImage>
                  <div
                    class="w-[50px] h-[50px] object-cover rounded-full flex justify-center items-center border"
                  >
                    <mat-icon class="!w-full !h-full">person</mat-icon>
                  </div>
                </ng-template>

                <!-- rating -->
                <!-- <div
                  class="flex absolute bottom-[-3px] bg-white-color items-center border-2 px-2 rounded-full border-[#DDDDDD]"
                  *ngIf="orderDetails?.rating != -1"
                >
                  <span
                    class="text-[12px] text-black-color mr-1 font-semibold"
                    >{{ orderDetails?.rating?.toFixed(1) }}</span
                  >

                  <img
                    src="/assets/images/ui/star.svg"
                    alt=""
                    class="w-[22px] aspect-square"
                  />
                </div> -->
              </div>

              <div class="flex items-start justify-between w-full gap-3">
                <div class="flex flex-col gap-5">
                  <h4
                    class="text-[16px] mb-[-10px] z-10 md:leading-[30px] sm:leading-[30px] leading-[30px] font-semibold text-blue-theme-color"
                  >
                    Driver ~
                    {{ driver.driverName | titlecase }}
                  </h4>

                  <a
                    [matTooltip]="driver?.driverPhone"
                    [href]="
                      'tel:' + this.handleZeroDriverNumber(driver?.driverPhone)
                    "
                    class="mt-[-10px] !px-0 flex items-center gap-[5px] text-sm"
                  >
                    <img
                      class="w-[15px] h-[15px]"
                      src="assets/images/ui/phone-call.png"
                      alt=""
                    />
                    {{ driver?.driverPhone }}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="absolute top-4 right-4">
          <div class="flex flex-col items-end gap-[5px]">
            <span
              class="rounded-md md:px-[10px] sm:px-[6px] px-[6px] md:py-[6px] sm:py-[4px] py-[4px] text-white-color text-sm font-normal"
              [ngClass]="GetInterRegionalStatusClass(orderDetail?.orderStatus)"
              >{{ GetInterRegionalStatus(orderDetail?.orderStatus) }}</span
            >
            <p
              *ngIf="this.orderDetail?.isScheduled !== 0"
              class="text-[12px] sm:text-sm leading-5 font-medium"
            >
              Schedule at
              {{ this.orderDetail?.scheduleDate | date : "mediumDate" }}
              {{ this.orderDetail?.scheduleDate | date : "shortTime" }}
            </p>
          </div>
        </div>
      </div>

      <!-- Pickup Location -->
      <div
        class="bg-white border border-[#D8DFE7] rounded-xl p-6 flex flex-col gap-2"
      >
        <span class="font-bold text-blue-theme-color">Pickup Location</span>
        <span class="font-semibold">{{ order?.pickup?.name }}</span>
        <span class="text-sm">{{ order?.pickup?.address }}</span>
        <div class="flex items-center gap-2 mt-2">
          <img
            src="assets/images/icons/door-pickup.svg"
            class="w-5 h-5"
            alt="Door Pickup"
          />
          <span class="text-blue-theme-color text-sm">Door Pickup</span>
        </div>
      </div>

      <!-- Dropoff Locations -->
      <div
        *ngFor="let dropLocation of dropDetail; let i = index"
        class="bg-white border border-[#D8DFE7] rounded-xl overflow-hidden"
      >
        <!-- Header for all dropoff locations -->
        <div
          class="p-4 sm:p-6 flex flex-col sm:flex-row sm:justify-between sm:items-center gap-3 sm:gap-0 cursor-pointer hover:bg-gray-50 transition-colors duration-200"
          (click)="toggleDropoffExpansion(i)"
        >
          <div class="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-3">
            <div>
              <span class="font-bold text-blue-theme-color text-sm sm:text-base"
                >Dropoff Location {{ i + 1 }}</span
              >
            </div>
            <div class="">
              <span
                class="rounded-md px-2 sm:px-[10px] py-1 sm:py-[6px] text-white-color text-xs leading-5 sm:leading-7 font-normal text-nowrap"
                [ngClass]="
                  GetInterRegionalStatusClass(dropLocation?.dropStatus)
                "
                >{{ GetInterRegionalStatus(dropLocation?.dropStatus) }}</span
              >
            </div>
          </div>
          <div class="flex flex-col sm:flex-row gap-2 sm:items-center">
            <div class="flex items-center">
              <button
                mat-ripple
                (click)="
                  $event.stopPropagation(); shareDropTracking(dropLocation, i)
                "
                class="!text-blue-theme-color flex items-center gap-1 px-2 py-1 rounded border border-blue-200 bg-transparent hover:!bg-blue-50"
              >
                <span class="text-[12px] !text-blue-theme-color"
                  >Share Tracking Info</span
                >
              </button>
            </div>
            <span class="text-xs sm:text-sm text-[#7C8390]"
              >Expected delivery:
              {{ getFormattedExpectedDelivery(dropLocation) }}</span
            >
            <mat-icon
              class="text-blue-theme-color transition-transform duration-200 self-end sm:self-auto"
              [class.rotate-180]="isDropoffExpanded(i)"
            >
              keyboard_arrow_down
            </mat-icon>
          </div>
        </div>

        <!-- Detailed view - expandable accordion -->
        <div
          *ngIf="isDropoffExpanded(i)"
          class="px-4 sm:px-6 pb-4 sm:pb-6 flex flex-col gap-3 sm:gap-4 transition-all duration-300 rounded-b-xl"
        >
          <div class="flex flex-col gap-[6px]">
            <p class="font-semibold text-sm sm:text-base">
              {{ dropLocation?.dropOffName }}
              <span
                *ngIf="dropLocation.isPhlenuTrustCheckApplied"
                class="inline-flex items-center gap-1 bg-[#ddf5db] text-green-color text-[10px] sm:text-[12px] font-medium px-2 sm:px-3 py-1 rounded-full"
                >🛡️ Verified</span
              >
            </p>
            <span class="text-xs sm:text-sm">{{
              dropLocation?.dropOffAdd
            }}</span>
          </div>

          <div
            class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4 mt-2"
          >
            <div>
              <span class="text-xs text-[#7C8390] font-medium"
                >Delivery Plan</span
              >
              <div class="flex items-center gap-1 mt-1">
                <img
                  src="assets/images/icons/regular.svg"
                  class="w-5 sm:w-[22px]"
                  alt="Regular"
                />
                <span class="text-blue-theme-color text-xs sm:text-sm">{{
                  getDeliveryPlan(dropLocation.deliveryPlan)
                }}</span>
              </div>
            </div>
            <div>
              <span class="text-xs text-[#7C8390] font-medium"
                >What are we handling?</span
              >
              <div class="flex items-start gap-1 mt-1">
                <img
                  [src]="
                    dropLocation.sendingItemUrl
                      ? dropLocation.sendingItemUrl
                      : 'assets/images/icons/other.png'
                  "
                  class="w-5 sm:w-[22px]"
                  [alt]="getSendingItemIcon(dropLocation.sendingItemKey)"
                />

                <span class="text-blue-theme-color text-xs sm:text-sm">{{
                  dropLocation.sendingItemName
                }}</span>
              </div>
            </div>
            <div>
              <span class="text-xs text-[#7C8390] font-medium"
                >Package Size</span
              >
              <div class="flex items-center gap-1 mt-1">
                <img
                  [src]="getPackageSizeIcon(dropLocation.packageSize)"
                  class="w-5 sm:w-[22px]"
                  alt="Package Size"
                />
                <span class="text-blue-theme-color text-xs sm:text-sm">{{
                  getPackageSize(dropLocation.packageSize)
                }}</span>
              </div>
            </div>
            <div>
              <span class="text-xs text-[#7C8390] font-medium"
                >Security Cover</span
              >
              <div class="flex items-center gap-1 mt-1">
                <img
                  src="assets/images/bulkOrder/trustCheck.svg"
                  class="w-4 h-4 sm:w-5 sm:h-5"
                  alt="Security Cover"
                />
                <span class="text-blue-theme-color text-xs sm:text-sm">{{
                  dropLocation?.isCoverApplied ? "Enable" : "Disable"
                }}</span>
              </div>
            </div>
            <div>
              <span class="text-xs text-[#7C8390] font-medium"
                >Delivery Fee</span
              >
              <div class="flex items-center gap-1 mt-1">
                <mat-icon class="tracking-step-icons">local_shipping</mat-icon>
                <span class="text-blue-theme-color text-xs sm:text-sm">{{
                  dropLocation?.totalDropCharges
                }}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Tracking Information (expandable accordion) -->

        <div
          *ngIf="
            isDropoffExpanded(i) &&
            GetInterRegionalStatus(dropLocation?.dropStatus) !== 'Returned' &&
            GetInterRegionalStatus(dropLocation?.dropStatus) !== 'Cancelled'
          "
          class="bg-[#FDF9F8] py-4 sm:py-[20px] px-4 sm:px-[25px] transition-all duration-300 rounded-b-xl"
        >
          <h2
            class="text-base sm:text-lg font-semibold text-blue-theme-color mb-4 sm:mb-6"
          >
            Tracking Information
          </h2>

          <div class="relative">
            <!-- Progress line - hidden on mobile, visible on larger screens -->
            <div class="hidden sm:block tracking-progress-line">
              <div
                class="tracking-progress-active"
                [style.width.%]="getProgressBarWidth(dropLocation)"
              ></div>
            </div>

            <!-- Steps -->
            <div
              class="relative flex flex-col sm:flex-row sm:justify-between gap-6 sm:gap-0"
            >
              <!-- Order Placed -->
              <div class="tracking-step-container">
                <div
                  class="tracking-step-circle {{
                    getStepStatus(1, dropLocation)
                  }}"
                >
                  <mat-icon
                    class="tracking-step-icon"
                    *ngIf="getStepStatus(1, dropLocation) === 'completed'"
                    >check</mat-icon
                  >
                  <mat-icon
                    class="tracking-step-icon"
                    *ngIf="getStepStatus(1, dropLocation) !== 'completed'"
                    >inventory_2</mat-icon
                  >
                </div>
                <div class="tracking-step-content">
                  <h3
                    class="tracking-step-title {{
                      getStepStatus(1, dropLocation)
                    }} text-sm sm:text-base"
                  >
                    Order Placed
                  </h3>
                  <p class="tracking-step-timestamp text-xs sm:text-sm">
                    {{ order?.date }}, {{ order?.time }}
                  </p>
                </div>
              </div>

              <!-- Scheduled for Pickup -->
              <div class="tracking-step-container">
                <div
                  class="tracking-step-circle {{
                    getStepStatus(2, dropLocation)
                  }}"
                >
                  <mat-icon
                    class="tracking-step-icon"
                    *ngIf="getStepStatus(2, dropLocation) === 'completed'"
                    >check</mat-icon
                  >
                  <mat-icon
                    class="tracking-step-icon"
                    *ngIf="getStepStatus(2, dropLocation) !== 'completed'"
                    >schedule</mat-icon
                  >
                </div>
                <div class="tracking-step-content">
                  <h3
                    class="tracking-step-title {{
                      getStepStatus(2, dropLocation)
                    }} text-sm sm:text-base"
                  >
                    {{
                      GetInterRegionalStatus(dropLocation?.dropStatus) ===
                        "In transit" ||
                      GetInterRegionalStatus(dropLocation?.dropStatus) ===
                        "Re-Scheduled" ||
                      GetInterRegionalStatus(dropLocation?.dropStatus) ===
                        "In Transit Hold" ||
                      GetInterRegionalStatus(dropLocation?.dropStatus) ===
                        "Delivered"
                        ? "Picked Up "
                        : "Scheduled for Pickup"
                    }}
                  </h3>
                </div>
              </div>

              <!-- In Transit -->
              <div class="tracking-step-container">
                <div
                  class="tracking-step-circle {{
                    getStepStatus(3, dropLocation)
                  }}"
                >
                  <mat-icon
                    class="tracking-step-icon"
                    *ngIf="getStepStatus(3, dropLocation) === 'completed'"
                    >check</mat-icon
                  >
                  <mat-icon
                    class="tracking-step-icon"
                    *ngIf="getStepStatus(3, dropLocation) !== 'completed'"
                    >local_shipping</mat-icon
                  >
                </div>
                <div class="tracking-step-content">
                  <h3
                    class="tracking-step-title {{
                      getStepStatus(3, dropLocation)
                    }} text-sm sm:text-base"
                  >
                    {{
                      GetInterRegionalStatus(dropLocation?.dropStatus) ==
                      "Re-Scheduled"
                        ? "Re-Scheduled"
                        : GetInterRegionalStatus(dropLocation?.dropStatus) ==
                          "In Transit Hold"
                        ? "In Transit Hold"
                        : "In
                    Transit"
                    }}
                  </h3>
                </div>
              </div>

              <!-- Expected Delivery -->
              <div class="tracking-step-container">
                <div
                  class="tracking-step-circle {{
                    getStepStatus(4, dropLocation)
                  }}"
                >
                  <mat-icon
                    class="tracking-step-icon"
                    *ngIf="getStepStatus(4, dropLocation) === 'completed'"
                    >check</mat-icon
                  >
                  <mat-icon
                    class="tracking-step-icon"
                    *ngIf="getStepStatus(4, dropLocation) !== 'completed'"
                    >place</mat-icon
                  >
                </div>
                <div class="tracking-step-content">
                  <h3
                    class="tracking-step-title {{
                      getStepStatus(4, dropLocation)
                    }} text-sm sm:text-base"
                  >
                    Expected Delivery
                  </h3>
                  <p class="tracking-step-timestamp text-xs sm:text-sm">
                    {{ getFormattedExpectedDelivery(dropLocation) }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Right Section: Payment Summary -->
    <div class="w-full lg:w-[350px] flex-shrink-0">
      <div class="bg-white border border-[#D8DFE7] rounded-xl p-6">
        <span class="font-bold text-blue-theme-color block mb-4"
          >Payment Summary</span
        >

        <div
          class="flex flex-col w-full shadow-sm border border-[#D8DFE7] rounded-lg mb-4"
        >
          <ng-container
            *ngFor="let dropoff of this.dropDetail; let dropIndex = index"
          >
            <!-- Route Card Design -->
            <div class="route-card bg-white p-4">
              <!-- Header with title and numbers -->
              <div class="flex justify-between items-start">
                <div class="flex items-center gap-2">
                  <span
                    class="text-sm text-black-color font-semibold capitalize"
                  >
                    {{ dropoff?.dropOffName }}
                    <span
                      *ngIf="this.dropDetail?.[dropIndex]?.isPhlenuTrustCheckApplied"
                      class="inline-flex items-center bg-[#ddf5db] text-green-color text-[10px] font-medium ml-1 px-2 rounded-full"
                      >🛡️ Verified</span
                    >
                  </span>
                </div>
                <div class="flex flex-col items-end gap-1">
                  <!-- Dropoff Fee Display -->
                  <div class="dropoff-fee-badge">
                    <mat-icon>local_shipping</mat-icon>
                    <span> Delivery Fee: {{ dropoff?.totalDropCharges }} </span>
                  </div>
                </div>
              </div>

              <!-- Address below route -->
              <div class="mt-1">
                <span class="text-xs text-gray-500 line-clamp-2">
                  {{ dropoff?.dropOffAdd }}
                </span>
              </div>
            </div>

            <span
              class="px-2"
              *ngIf="dropIndex !== this.dropDetail?.length - 1"
            >
              <mat-divider></mat-divider>
            </span>
          </ng-container>
        </div>

        <!-- Delivery Charges -->
        <div class="flex justify-between mb-3">
          <span class="text-sm text-blue-theme-color">Delivery Fee</span>
          <span class="font-semibold text-blue-theme-color">{{
            orderDetail?.basePrice || 0
          }}</span>
        </div>

        <!-- Dropoff Fee -->
        <div
          *ngIf="hasDoorToDoorDropoff() && orderDetail?.dropoffFee > 0"
          class="flex justify-between mb-3"
        >
          <span class="text-sm text-blue-theme-color">Dropoff Fee</span>
          <span class="font-semibold text-blue-theme-color">{{
            orderDetail?.dropoffFee
          }}</span>
        </div>

        <!-- Pickup Fee -->
        <div
          *ngIf="orderDetail?.pickupFee > 0"
          class="flex justify-between mb-3"
        >
          <span class="text-sm text-blue-theme-color">Pickup Fee</span>
          <span class="font-semibold text-blue-theme-color">{{
            orderDetail?.pickupFee
          }}</span>
        </div>

        <!-- Phlenu TrustCheck -->
        <div
          *ngIf="isPhlenuTrustCheckApplied()"
          class="flex justify-between mb-3"
        >
          <span class="text-sm text-blue-theme-color">Phlenu TrustCheck</span>
          <span class="font-semibold text-blue-theme-color">{{
            orderDetail?.phlenuTrustCheckCommision || 0
          }}</span>
        </div>

        <!-- Security Cover Charges -->
        <div
          *ngIf="orderDetail?.isCoverApplied || orderDetail?.totalCoverFee > 0"
          class="flex justify-between mb-3"
        >
          <span class="text-sm text-blue-theme-color"
            >Security Cover Charges</span
          >
          <span class="font-semibold text-blue-theme-color">{{
            orderDetail?.totalCoverFee || 0
          }}</span>
        </div>

        <!-- Total Delivery Fee -->
        <div *ngIf="orderDetail?.paymentDirection != 2">
          <hr class="my-3 border-[#E3E3E3]" />
          <div class="flex justify-between mb-3">
            <span class="text-sm text-blue-theme-color font-semibold"
              >Total Delivery Fee</span
            >
            <span class="font-semibold text-blue-theme-color">{{
              orderDetail?.totalCharges || 0
            }}</span>
          </div>
        </div>

        <!-- Total Item Cost -->
        <div
          *ngIf="
            isCashCollectionApplied() &&
            orderDetail?.cashCollected > 0 &&
            orderDetail?.paymentDirection != 2
          "
        >
          <hr class="my-3 border-[#E3E3E3]" />
          <div class="flex justify-between mb-3">
            <span class="text-sm text-blue-theme-color font-semibold"
              >Total Item Cost</span
            >
            <span class="font-semibold text-blue-theme-color">{{
              orderDetail?.cashCollected || 0
            }}</span>
          </div>
        </div>

        <!-- Delivery Fee Subtraction -->
        <div
          *ngIf="
            orderDetail?.isSubtractPriceFromDeliveryFee == 1 ||
            orderDetail?.isSubtractPriceFromPickUpFee == 1
          "
          class="flex justify-between mb-3"
        >
          <div class="flex items-center gap-[4px]">
            <span class="text-sm text-blue-theme-color">(-) Delivery Fee</span>
            <mat-icon
              matTooltipClass="custom-tooltip"
              matTooltip="Your delivery fee includes the cost to deliver, drop-off handling, and extra services like item verification and cash collection (if applicable)"
              matTooltipPosition="above"
              class="text-dark-gray cursor-pointer text-[12px]"
              >info_outline</mat-icon
            >
          </div>

          <span class="font-semibold text-blue-theme-color">{{
            getDeliveryFee()
          }}</span>
        </div>

        <!-- Final Total -->
        <hr class="my-3 border-[#E3E3E3]" />
        <div class="flex justify-between items-center">
          <span class="text-[#F54720] font-bold text-xl">{{
            getTotalAmountLabel()
          }}</span>
          <span class="text-[#F54720] font-bold text-xl">{{
            getTotalAmount()
          }}</span>
        </div>
        <div
          *ngIf="orderDetail?.isCashCollectionApplied == 1"
          class="flex justify-between items-center bg-blue rounded-[6px] text-white-color text-[12px] py-[4px] px-[6px] mt-[10px]"
        >
          <span>Cash Collection Fee</span>
          <span>{{ orderDetail?.cashCollectionFee }}</span>
        </div>
        <div
          *ngIf="
            orderDetail?.isCashCollectionApplied == 1 && totalCashCollected > 0
          "
          class="flex justify-between items-center bg-blue rounded-[6px] text-white-color text-[12px] py-[4px] px-[6px] mt-[10px]"
        >
          <span>Total Cash Collected</span>
          <span>{{ totalCashCollected }}</span>
        </div>
      </div>
      <button
        *ngIf="this.orderDetail.orderStatus == 1"
        (click)="onCancelOrder()"
        mat-flat-button
        class="bg-orange-color w-full !mt-3 text-white-color flat-button text-lg font-bold"
      >
        <span *ngIf="!this.isCancelingOrder">Cancel Order</span>
        <mat-progress-spinner
          class="custom-spinner text-white-color"
          *ngIf="this.isCancelingOrder"
          [diameter]="24"
          [mode]="'indeterminate'"
        ></mat-progress-spinner>
      </button>
    </div>
  </div>

  <!-- Error State -->
  <div *ngIf="!isLoading && error" class="text-center py-8">
    <div class="text-red-500 text-lg">{{ error }}</div>
    <button mat-flat-button (click)="loadOrderDetails()" class="mt-4">
      Try Again
    </button>
  </div>
</div>
